@for (pln of item.items; track pln.planningEntity.id) {
    <div
        class="planning offset-{{ pln.minutesOffset }} duration-{{ pln.duration }} {{
            pln.planningEntity.id !== pln.planning.planning_has_id ? 'secondary' : ''
        }}"
        [class.see-through]="ctrlKey"
        [class.use-once]="pln.planningEntity?.entity?.use_once"
        [class.highlight]="pln.planning === highlightedPlanning"
        [class.no-people]="isTeam && people.get(pln.planning.id) === 0"
        (click)="open(pln)">
        <div
            class="info status-{{ pln.planning.status_key }}"
            (mouseenter)="mouseEnter(pln, $event)"
            (mousemove)="mouseMove(pln, $event)"
            (mouseleave)="mouseLeave(pln)">
            <div class="main">
                @if (isTeam) {
                    <div class="time team-time d-flex justify-content-between gap-1">
                        @let beginDateFormat =
                            pln.planningEntity.entity.use_once &&
                            item.items.length > 1 &&
                            (pln.planningEntity.begindate | date: 'mm') === '00'
                                ? 'H'
                                : 'H:mm';
                        <span>
                            {{ pln.planningEntity.begindate | date: beginDateFormat }}-{{
                                pln.planningEntity.enddate | date: 'H:mm'
                            }}
                        </span>
                        <span>{{ pln.planning.worknumber ?? pln.planning.afas_project_id }}</span>
                    </div>
                    <div class="team-row d-flex justify-content-between gap-2">
                        @if (!pln.planningEntity.entity.use_once || item.items.length === 1) {
                            <span>
                                {{
                                    pln.planningEntity.entity.use_once
                                        ? pln.planningEntity.entity.name
                                        : pln.planningEntity.name || pln.planning.description
                                }}
                            </span>
                        }
                        <span>{{ pln.planning.contractor | contractorShort }}</span>
                    </div>
                } @else {
                    <div class="time">
                        {{ pln.planningEntity.begindate | date: 'H:mm' }}-{{
                            pln.planningEntity.enddate | date: 'H:mm'
                        }}
                    </div>
                    <div class="name">
                        {{
                            pln.planningEntity.entity.use_once
                                ? pln.planningEntity.entity.name
                                : pln.planningEntity.name
                        }}
                    </div>
                }
            </div>
            <div class="other-info">
                @if (pln.planning.status_key === PlanningStatus.PlanningGeblokkeerd) {
                    <div class="description">
                        {{ pln.planning.description }}
                    </div>
                }
                @if (pln.planningEntity.driver) {
                    <span class="ucfirst">
                        {{ pln.planningEntity.driver }}
                    </span>
                    <br />
                }
                @if (!isTeam) {
                    @if (pln.planning.worknumber || pln.planning.afas_project_id) {
                        {{ pln.planning.worknumber ?? pln.planning.afas_project_id }} -
                    }
                    {{ pln.planning.contractor | contractorShort }}<br />
                }
            </div>
            @if (
                (pln.planningEntity.entity.use_once || isTeam) &&
                pln.planningEntity.entitytype_key !== 'rentalEquipment' &&
                pln.planningEntity.entitytype_key !== 'wipeTruck' &&
                ![PlanningStatus.PlanningSlaapdag, PlanningStatus.PlanningGeblokkeerd].includes(pln.planning.status_key)
            ) {
                <div class="d-flex justify-content-between">
                    <div class="tons">{{ tons.get(pln.planning.id) }}</div>
                    <div class="trucks">{{ trucks.get(pln.planning.id) }}</div>
                    @if (isTeam && (!pln.planningEntity.entity.use_once || item.items?.length === 1)) {
                        <div class="people">{{ people.get(pln.planning.id) }}</div>
                    }
                    <div class="daynight" [class.night]="night.get(pln.planning.id)"></div>
                </div>
            }
        </div>
    </div>
}
@if (hourChoose !== null && (!isFixed || viewModel.addPlanningFixed)) {
    <div class="planning duration-{{ defaultDuration * 60 }} selector offset-{{ hourChoose }}" #timeChooseDiv></div>
}
@if (item.unavailableDays) {
    <div class="unavailable duration-{{ item.unavailableDays }}" (dblclick)="openEntityEdit()">Niet beschikbaar</div>
}
